import React, { Fragment } from 'react';
import { arrayOf, shape, string, oneOf, array, oneOfType } from 'prop-types';
import useStyles from 'hooks/useStyles';

import { SUBTITLE, IMAGE, TEXT, BULLET_POINT } from './constants';
import styles from './Information.scss';

function Information({ info }) {
  useStyles(styles);

  const renderBulletPointItem = item => (
    <li key={item}>
      <span className={styles.listStyle} />
      <span>{item}</span>
    </li>
  );

  const ELEMENT = {
    [SUBTITLE]: children => <h3 className={styles.subTitle}>{children}</h3>,
    [IMAGE]: url => <img className={styles.img} alt="" src={url} />,
    [TEXT]: children => (
      <p
        className={styles.text}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: children,
        }}
      />
    ),
    [BULLET_POINT]: children => (
      <ul className={styles.bulletPoint}>
        {children.map(renderBulletPointItem)}
      </ul>
    ),
  };

  return (
    <div>
      {info.map(({ uuid, type, value }) => (
        <Fragment key={uuid}>{ELEMENT[type](value)}</Fragment>
      ))}
    </div>
  );
}

Information.propTypes = {
  info: arrayOf(
    shape({
      type: oneOf([SUBTITLE, IMAGE, TEXT, BULLET_POINT]).isRequired,
      value: oneOfType([string, array]).isRequired,
      uuid: string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default Information;
